import React, { Component } from 'react';
import Pagination from 'rc-pagination';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import s from 'rc-pagination/assets/index.css';
import t from '../../../styles/customPagination.css';
import messages from '../../../locale/jsonMessages';


class CustomPagination extends Component {

  constructor(props) {
    super(props);
    this.renderShowTotal = this.renderShowTotal.bind(this);
  }

  renderShowTotal(total, range) {
    return (
      <div className={s.resultsCount}><span>{range[0]}</span><span>&nbsp;–&nbsp;</span><span>{range[1]}</span><span className='displayInlineRTL'>&nbsp;<FormattedMessage  {...messages.of} />&nbsp;</span><span>{total}</span><span>&nbsp;<FormattedMessage  {...messages.rentals} /></span></div>
    );
  }

  render() {
    const { total, defaultCurrenct, defaultPageSize, handleChange, current } = this.props;

    return (
      <div className={"customPaginationContainer"}>
        <Pagination
          defaultCurrent={defaultCurrenct}
          current={current}
          total={total}
          defaultPageSize={defaultPageSize}
          onChange={handleChange}
          showTotal={(total, range) => this.renderShowTotal(total, range)}
          locale={"en_US"}
          prevIcon={<span className='rc-pagination-navigation-icon' />}
          nextIcon={<span className='rc-pagination-navigation-icon' />}
          jumpPrevIcon={
            <span className='rc-pagination-jump-custom-icon'>
              <span className='rc-pagination-jump-beforeHover-icon'>&#8226;&#8226;&#8226;</span>
              <span className='rc-pagination-jump-afterHover-icon'>&#8249;&#8249;</span>
            </span>
          }
          jumpNextIcon={
            <span className='rc-pagination-jump-custom-icon'>
              <span className='rc-pagination-jump-beforeHover-icon'>&#8226;&#8226;&#8226;</span>
              <span className='rc-pagination-jump-afterHover-icon'>&#8250;&#8250;</span>
            </span>
          }
          align={"center"}
        />
      </div>
    );
  }


}
export default injectIntl(withStyles(s, t)(CustomPagination));